import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { toggleFigurinePreview } from '../../actions/uiActions';
import { getCurrentPatternThumbnailUri } from '../../reducers/currentPattern';
import { getSewpatGalleryOverlay } from '../../reducers/sewpats';
import {
    getPreviewRepeats,
    getShowRecoloringLoader,
} from '../../reducers/ui.recoloring';
import FigurineOverlay from './FigurineCanvasPreview';
import RecoloredPreview from './RecoloredPatternPreview';

import Loader from './RecoloringLoader';

class PatternColorPreview extends React.PureComponent {

    handleClick = () => this.props.handleFigurineToggle();

    PatternPreview = styled.div`
            position: relative;
            width: 98%;
            max-height: 85vh;
            margin: 1em auto;
            overflow: hidden;
            transition: all 1s ease-in;

            & .fade-enter {
              opacity: 0.01;
              transition: all 1s ease-in;
            }

            & .fade-enter.fade-enter-active {
              transition: all 1s ease-in;
              opacity: 0.9;
            }

            & .fade-exit {
              opacity: 0.9;
              transition: all 1s ease-in;
            }

            & .fade-exit.fade-exit-active {
              transition: all 1s ease-in;
              opacity: 0.01;
            }
        `;

    StyledLoader = styled(Loader)`
            background-color: rgba(255, 255, 255, 0.5);
            position: absolute;
            top: 1.6em;
            left: 0;
            width: 100%;
            height: 95%;
            height: calc(100% - 1.6em);
            display: flex;
            align-items: center;
        `;

    render() {
        const { col, rows, imgSrc, showLoader, overlay, sewpatId } = this.props;

        const toogleLoader = () => showLoader ? <this.StyledLoader /> : null;
        return (
            <this.PatternPreview onClick={this.handleClick}>
                <RecoloredPreview col={col} rows={rows} imgSrc={imgSrc}>
                    {toogleLoader()}
                    <FigurineOverlay
                        col={col} rows={rows} imgSrc={imgSrc}
                        figurine={overlay} sewpatId={sewpatId}
                    />
                </RecoloredPreview>
            </this.PatternPreview>
        );
    }
}

const mapDispatchToProps = dispatch => (
    {
        handleFigurineToggle: () => dispatch(toggleFigurinePreview()),
    }
);

const makeMapStateToProps = initialState => {
    const { patternid, sewpatId } = initialState.location.payload;
    const overlay = getSewpatGalleryOverlay(initialState);
    const mapStateToProps = state => {
        const { col, rows } = getPreviewRepeats(state);
        const imgSrc = getCurrentPatternThumbnailUri(state, patternid);
        return {
            imgSrc,
            showLoader: getShowRecoloringLoader(state),
            col,
            rows,
            sewpatId,
            overlay,
        };
    };
    return mapStateToProps;
};

export default connect(
    makeMapStateToProps,
    mapDispatchToProps,
)(PatternColorPreview);




// WEBPACK FOOTER //
// ./src/components/pattern/PatternColorPreview.js